import { Injectable } from '@angular/core';
import {lastValueFrom} from 'rxjs';
import {ApiService} from './api.service';

@Injectable({
  providedIn: 'root'
})
export class SiteConfigService {

  config = new Map<string, string>();

  constructor(private api: ApiService) {
    this.loadConfig().then();
  }

  async loadConfig(): Promise<void> {
    const options = await lastValueFrom(this.api.siteSettings());
    for (const option of options) {
      this.config.set(option.setting, option.data);
    }
  }

  isEFileSubmissionMaintenanceEnabled(): boolean {
    return this.config.has('MaintenanceEFileSubmission');
  }

  isAmpGCMMaintenanceEnabled(): boolean {
    return this.config.has('MaintenanceAmpGCM');
  }

  getEFileMaintenanceAlert(): string {
    return this.config.get('MaintenanceEFileSubmission');
  }

  getMncMaintenanceMessage(): string {
    return this.config.get('MaintenanceMNC');
  }

  getProfileMaintenanceMessage(): string {
    return this.config.get('MaintenanceLogin');
  }

  getENotificationMaintenanceMessage(): string {
    return this.config.get('MaintenanceENotification');
  }

  isENotificationDisabled(): boolean {
    return this.getENotificationMaintenanceMessage() !== undefined;
  }

  isProfilePageDisabled(): boolean {
    return this.getProfileMaintenanceMessage() !== undefined;
  }

  isEFileDisabled(): boolean {
    return this.getEFileMaintenanceAlert() !== undefined;
  }
}
